// const wrapper = document.querySelector('.gfgFreeGiftWrapperV3');
// wrapper.addEventListener('click', function() {
// const buttonToRotate = this.querySelector('.gfgFreeGiftDropDownButton');
 
// buttonToRotate.classList.toggle('rotated');
 
// });

if (!customElements.get("product-info")) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setRecentlyViewedProduct();
      this.setFootwearProductsSizes();
      this.hideCollapseDetailsSizeTable();
    }
    setRecentlyViewedProduct() {
      const { productHandle } = this.dataset;
      let recentlyViewedProducts = JSON.parse(localStorage.getItem("__sm_recently_viewed_products")) || [];
      recentlyViewedProducts.unshift(productHandle);
      recentlyViewedProducts = recentlyViewedProducts.filter((item) => typeof item === "string" && item !== "");
      localStorage.setItem(
        "__sm_recently_viewed_products",
        JSON.stringify([...new Set(recentlyViewedProducts)].slice(0, 16))
      );
    }
    setFootwearProductsSizes() {
      const select = this.querySelector(".sm-footwear-size-selector__select");
      if (!select)
        return;
      const fieldsetElement = select.closest(".sm-options__fieldset");
      if (!fieldsetElement)
        return;
      select == null ? void 0 : select.addEventListener("change", (event) => {
        event.stopPropagation();
        const value = event.target.value;
        const surfaceSpan = this.querySelector(".sm-footwear-size-selector__surface span");
        if (surfaceSpan)
          surfaceSpan.innerHTML = event.target.options[event.target.selectedIndex].text;
        const checkedLabel = fieldsetElement == null ? void 0 : fieldsetElement.querySelector(".sm-options__label [data-checked]");
        const checkedOptionLabel = fieldsetElement == null ? void 0 : fieldsetElement.querySelector(
          '.sm-options__item input[type="radio"]:checked + label'
        );
        checkedLabel.innerHTML = (checkedOptionLabel == null ? void 0 : checkedOptionLabel.getAttribute(`data-${value}`)) || "";
        const optionLabels = fieldsetElement == null ? void 0 : fieldsetElement.querySelectorAll(".sm-options__item label");
        optionLabels.forEach((label) => {
          let labelValue = label.getAttribute(`data-${value}`) || "";
          label.dataset.value = labelValue;
          label.innerHTML = labelValue;
        });
        window.footwearSizeSelected = value;
      });
      const footwearSizeMap = {
        US: "us-men",
        CA: "us-men",
        GB: "uk"
      };
      const selectedSize = window.footwearSizeSelected || footwearSizeMap[Shopify.country];
      if (selectedSize) {
        select.value = selectedSize;
        select.dispatchEvent(
          new Event("change", {
            bubbles: true,
            cancelable: true
          })
        );
      }
    }
    hideCollapseDetailsSizeTable() {
      const tableList = this.querySelectorAll(".sm-collapse__details table");
      if (tableList == null ? void 0 : tableList.length) {
        const keywords = ["size", "s", "m", "l", "xl", "2xl", "3xl", "4xl", "cm", "kg"];
        tableList.forEach((element) => {
          let reliability = 0;
          const tds = element.querySelectorAll("td");
          if (tds.length) {
            for (let td of tds) {
              let str = td.innerHTML.replace(/\s/g, "");
              if (keywords.includes(str == null ? void 0 : str.toLowerCase())) {
                reliability++;
              }
            }
          }
          if (reliability > 2) {
            element.style.display = "none";
          }
        });
      }
    }
  }
  customElements.define("product-info", ProductInfo);
}
if (!customElements.get("photo-lightbox")) {
  class PhotoLightbox extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (window.PhotoSwipeLightbox) {
        const gallery = this.querySelector(".gallery");
        this.lightbox = new PhotoSwipeLightbox({
          gallery,
          children: ".gallery-children",
          imageClickAction: "zoom",
          initialZoomLevel: "fit",
          secondaryZoomLevel: 1.2,
          spacing: 0,
          pswpModule: PhotoSwipe
        });
        this.lightbox.addFilter('itemData', (itemData, index) => {
          const webpSrc = itemData.element.dataset.pswpWebpSrc;
          if (webpSrc) {
            itemData.webpSrc = webpSrc;
          }
          return itemData;
        });
        this.lightbox.on('contentLoad', (e) => {
          const { content } = e;
          if(content.type == 'html'){
            e.preventDefault();
            content.element = document.createElement('div');
            content.element.className = 'pswp__template-container';
            const dom = content.data.element.querySelector('template')
            if(dom && dom.content){
              content.element.appendChild(dom.content);
            }
          }
        })
        this.lightbox.on('contentActivate', ({ content, slide }) => {
          if(content.type == 'html'){
            if(content.element.querySelector('video')){
              setTimeout(()=>{
                content.element.querySelector('video').load()
              }, 0)
            }
          }
        });
        this.lightbox.init();
      }
    }
  }
  customElements.define("photo-lightbox", PhotoLightbox);
}
if (!customElements.get("size-size-modal")) {
  class SizeChartModal extends ModalDialog {
    constructor() {
      super();
      // this.sortOrder = ["XXS", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"];
      this.sortOrder = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL","XXXXL", "2XL", "3XL", "4XL"];
      this.units = [];
      this.initialized = false;
    }
    connectedCallback() {
      // Inline charts stay inside their accordion; popup charts retain the
      // normal ModalDialog behavior that moves them to document.body.
      if (!this.hasAttribute("data-inline")) {
        super.connectedCallback?.();
      }
      // 确保在元素完全挂载后再初始化
      if (!this.initialized) {
        this.initializeUnits();
        this.handleDefaultSizeGuide();
        this.handleExclusiveSizeGuide();
        this.handleTabChange();
        this.handleTableHighlight();
        this.initializeCalculator();
        this.initialized = true;
      }
    }

    initializeCalculator() {
      const calcBtn = this.querySelector('#sm-size-calc-btn');
      if (calcBtn) {
        calcBtn.addEventListener('click', () => {
          this.calculateRecommendedSize();
        });
      }

      const atcBtn = this.querySelector('#sm-size-chart-atc-btn');
      if (atcBtn) {
        atcBtn.addEventListener('click', () => {
          const mainFormAtc = document.querySelector('product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"]');
          if (mainFormAtc) {
            mainFormAtc.click();
            // Close modal if popup modal close button exists
            const closeBtn = this.querySelector('.sm-modal__close');
            if (closeBtn) closeBtn.click();
          }
        });
      }
    }

    calculateRecommendedSize() {
      const hVal = parseFloat(this.querySelector('#sm-size-calc-height-val')?.value || 170);
      const hUnit = this.querySelector('#sm-size-calc-height-unit')?.value || 'cm';
      const wVal = parseFloat(this.querySelector('#sm-size-calc-weight-val')?.value || 60);
      const wUnit = this.querySelector('#sm-size-calc-weight-unit')?.value || 'kg';

      let heightCm = hUnit === 'in' ? hVal * 2.54 : hVal;
      let weightKg = wUnit === 'lbs' ? wVal * 0.453592 : wVal;

      let heightSize = 'XXL';
      if (heightCm < 163) heightSize = 'S';
      else if (heightCm <= 172) heightSize = 'M';
      else if (heightCm <= 178) heightSize = 'L';
      else if (heightCm <= 184) heightSize = 'XL';

      let weightSize = 'XXL';
      if (weightKg < 50) weightSize = 'S';
      else if (weightKg <= 65) weightSize = 'M';
      else if (weightKg <= 75) weightSize = 'L';
      else if (weightKg <= 85) weightSize = 'XL';

      const order = ['S', 'M', 'L', 'XL', 'XXL'];
      const size = order[Math.max(order.indexOf(heightSize), order.indexOf(weightSize))];

      const displayEl = this.querySelector('#sm-size-calc-size-display');
      if (displayEl) {
        displayEl.textContent = size;
      }
    }
    /**
     * 尺码表交互：鼠标移入/点击时，仅高亮当前单元格上方的（同列）和左边的（同行）单元格，形成 L 形高亮
     */
    handleTableHighlight() {
      const highlightClass = "sm-size-chart__cell--highlight";
      const highlightCurrentClass = "sm-size-chart__cell--highlight-current";
      const applyHighlight = (table, rowIndex, cellIndex) => {
        this.querySelectorAll(`.sm-size-chart__chart .${highlightClass}`).forEach((el) => el.classList.remove(highlightClass));
        this.querySelectorAll(`.sm-size-chart__chart .${highlightCurrentClass}`).forEach((el) => el.classList.remove(highlightCurrentClass));
        const rows = table.querySelectorAll("tr");
        // 上方：同列且行索引 < rowIndex 的单元格（含表头）
        for (let r = 0; r < rowIndex; r++) {
          const row = rows[r];
          if (!row) continue;
          const cell = row.cells[cellIndex];
          if (cell) cell.classList.add(highlightClass);
        }
        // 左边：同行且列索引 < cellIndex 的单元格
        const targetRow = rows[rowIndex];
        if (targetRow) {
          for (let c = 0; c < cellIndex; c++) {
            const cell = targetRow.cells[c];
            if (cell) cell.classList.add(highlightClass);
          }
          // 当前元素（使用单独类名以区分颜色）
          const currentCell = targetRow.cells[cellIndex];
          if (currentCell) currentCell.classList.add(highlightCurrentClass);
        }
      };
      const clearHighlight = () => {
        this.querySelectorAll(`.sm-size-chart__chart .${highlightClass}`).forEach((el) => el.classList.remove(highlightClass));
        this.querySelectorAll(`.sm-size-chart__chart .${highlightCurrentClass}`).forEach((el) => el.classList.remove(highlightCurrentClass));
      };
      // 仅在有悬停能力的设备（如 PC）上启用移入高亮，手机端仅点击高亮
      const hoverMedia = window.matchMedia("(hover: hover)");
      if (hoverMedia.matches) {
        this.addEventListener("mouseover", (e) => {
          const cell = e.target.closest("td, th");
          if (!cell) return;
          const table = cell.closest(".sm-size-chart__chart table");
          if (!table) return;
          const rowIndex = cell.closest("tr").rowIndex;
          const cellIndex = cell.cellIndex;
          applyHighlight(table, rowIndex, cellIndex);
        });
        this.addEventListener("mouseout", (e) => {
          const cell = e.target.closest("td, th");
          const table = cell?.closest(".sm-size-chart__chart table");
          if (!cell || !table) return;
          const related = e.relatedTarget;
          if (related && table.contains(related)) return;
          clearHighlight();
        });
      }
      // 点击高亮：PC 与手机端均生效
      this.addEventListener("click", (e) => {
        const cell = e.target.closest("td, th");
        if (!cell) return;
        const table = cell.closest(".sm-size-chart__chart table");
        if (!table) return;
        const rowIndex = cell.closest("tr").rowIndex;
        const cellIndex = cell.cellIndex;
        applyHighlight(table, rowIndex, cellIndex);
      });
    }
    initializeUnits() {
      const unitMap = new Map();
      // 首先从默认尺码表的 Tab 收集单位信息
      this.querySelectorAll(".sm-size-chart__tab").forEach((element) => {
        const key = element.dataset.key;
        if (!key) {
          return;
        }
        const convertToCm = Number(element.dataset.convertToCm);
        unitMap.set(key, isNaN(convertToCm) || convertToCm === 0 ? 1 : convertToCm);
      });
      // 如果没有 Tab（例如仅有专属尺码表），从内容区块中获取单位信息
      if (!unitMap.size) {
        this.querySelectorAll(".sm-size-chart__content").forEach((element) => {
          const key = element.dataset.key;
          if (!key) {
            return;
          }
          const convertToCm = Number(element.dataset.convertToCm);
          if (!unitMap.has(key)) {
            unitMap.set(key, isNaN(convertToCm) || convertToCm === 0 ? 1 : convertToCm);
          }
        });
      }
      this.units = Array.from(unitMap.entries()).map(([key, convertToCm]) => ({
        key,
        convertToCm
      }));
    }
    handleTabChange() {
      const tabsGroups = this.querySelectorAll(".sm-size-chart__tabs");
      tabsGroups.forEach((tabsElement) => {
        tabsElement.addEventListener("click", ({ target }) => {
          const tabElement = target.closest(".sm-size-chart__tab");
          if (!tabElement) {
            return;
          }
          const key = tabElement.dataset.key;
          this.querySelectorAll(".sm-size-chart__tab").forEach((element) => {
            if (element.dataset.key === key) {
              element.classList.add("active");
            } else {
              element.classList.remove("active");
            }
          });
          this.querySelectorAll(".sm-size-chart__content").forEach((element) => {
            if (element.dataset.key === key) {
              element.classList.remove("hidden");
            } else {
              element.classList.add("hidden");
            }
          });
        });
      });
    }
    handleTableHtml(data) {
      // 字段名映射：将数据中的 key 映射为显示名称
      const fieldNameMap = {
        // tops
        "chest circumference": "CHEST",

        // bottoms (flat measurements)
        "pants length": "LENGTH",
        "pant length": "LENGTH",
        "length": "LENGTH",
        "waistline": "WAIST",
        "waist": "WAIST",
        "hips": "HIP",
        "hip": "HIP",
        "foot": "HEM",
        "hem": "HEM",
        "hem foot": "HEM"
      };

      // 获取显示名称的辅助函数
      const normalizeFieldKey = (key) =>
        String(key ?? "")
          .trim()
          .replace(/\s+/g, " ")
          .toLowerCase();

      const getDisplayName = (key) => {
        const normalized = normalizeFieldKey(key);
        return fieldNameMap[normalized] || key;
      };

      // 确定要展示的尺码顺序：若数据 key 在 sortOrder 中则按 sortOrder 排，否则按数据 key 自身排序（支持腰带等非 S/M/L 格式）
      const dataKeys = Object.keys(data);
      const hasSortOrderMatch = dataKeys.some((k) => this.sortOrder.includes(k));
      const sizesToRender = hasSortOrderMatch
        ? this.sortOrder.filter((s) => data[s])
        : dataKeys.sort((a, b) => {
            const numA = parseFloat(String(a).match(/[\d.]+/)?.[0]) ?? 0;
            const numB = parseFloat(String(b).match(/[\d.]+/)?.[0]) ?? 0;
            return numA - numB;
          });

      let tableHtml = '<div class="sm-size-chart__chart"><table>\n<thead><tr>';
      tableHtml += "<th>SIZE</th>";
      const firstRow = Object.values(data)[0];
      for (let key in firstRow) {
        tableHtml += `<th>${getDisplayName(key)}</th>`;
      }
      tableHtml += "</tr></thead>\n<tbody>";
      for (let size of sizesToRender) {
        if (data[size]) {
          tableHtml += `<tr><td>${size}</td>`;
          for (let key in data[size]) {
            tableHtml += `<td>${data[size][key]}</td>`;
          }
          tableHtml += "</tr>\n";
        }
      }
      tableHtml += "</tbody></table></div>";
      return tableHtml;
    }
    extractMeasurement(row, measurement, keywords = []) {
      const measurementLower = measurement.toLowerCase();
      const entries = Object.entries(row || {}).filter(([key]) => key.toLowerCase().includes(measurementLower));
      if (!entries.length) {
        return "";
      }
      if (keywords.length) {
        const matched = entries.find(([key]) => {
          const lowerKey = key.toLowerCase();
          return keywords.some((keyword) => lowerKey.includes(keyword));
        });
        if (matched) {
          return matched[1];
        }
      }
      return entries[0][1];
    }
    transformDefaultDataForUnit(data, unitKey) {
      const unit = (unitKey || "").toLowerCase();
      const config = {
        inch: {
          waist: {
            label: "WAIST (IN)",
            keywords: ["(in", " inch", "in)", "waist(in", "waist in"]
          },
          height: {
            label: "HEIGHT (FT/IN)",
            keywords: ["ft/in", " ft", "(ft", "(in", " inch", "\""]
          },
          weight: { label: "WEIGHT (KG)", keywords: ["(kg", " kg"] },
          width: { label: "WIDTH (IN)", keywords: ["(in", " inch", "in)"] }
        },
        cm: {
          waist: {
            label: "WAIST (CM)",
            keywords: ["(cm", " cm", "centimeter"]
          },
          height: {
            label: "HEIGHT (CM)",
            keywords: ["(cm", " cm", "centimeter"]
          },
          weight: { label: "WEIGHT (KG)", keywords: ["(kg", " kg"] },
          width: { label: "WIDTH (CM)", keywords: ["(cm", " cm", "centimeter"] }
        }
      };
      const currentConfig = config[unit] || config.inch;
      const transformed = {};
      const columnUsage = {
        [currentConfig.waist.label]: false,
        [currentConfig.height.label]: false,
        [currentConfig.weight.label]: false,
        [currentConfig.width.label]: false
      };
      for (const size in data) {
        const row = data[size] || {};
        const waistValue = this.extractMeasurement(row, "waist", currentConfig.waist.keywords);
        const heightValue = this.extractMeasurement(row, "height", currentConfig.height.keywords);
        const weightValue = this.extractMeasurement(row, "weight", currentConfig.weight.keywords);
        const widthValue = this.extractMeasurement(row, "width", currentConfig.width.keywords);
        const resultRow = {};
        resultRow[currentConfig.waist.label] = waistValue ?? "";
        resultRow[currentConfig.height.label] = heightValue ?? "";
        resultRow[currentConfig.weight.label] = weightValue ?? "";
        resultRow[currentConfig.width.label] = widthValue ?? "";
        transformed[size] = resultRow;
        if (waistValue && `${waistValue}`.trim() !== "") {
          columnUsage[currentConfig.waist.label] = true;
        }
        if (heightValue && `${heightValue}`.trim() !== "") {
          columnUsage[currentConfig.height.label] = true;
        }
        if (weightValue && `${weightValue}`.trim() !== "") {
          columnUsage[currentConfig.weight.label] = true;
        }
        if (widthValue && `${widthValue}`.trim() !== "") {
          columnUsage[currentConfig.width.label] = true;
        }
      }
      const filtered = {};
      for (const size in transformed) {
        const row = transformed[size];
        const filteredRow = {};
        for (const key in row) {
          if (columnUsage[key]) {
            filteredRow[key] = row[key];
          }
        }
        filtered[size] = filteredRow;
      }
      return filtered;
    }
    handleReversalTableHtml(data) {
      const columns = Object.keys(data);
      const allSizes = Array.from(new Set(columns.flatMap((key) => Object.keys(data[key])))).sort(
        (a, b) => parseFloat(a) - parseFloat(b)
      );
      let html = `<div class="sm-size-chart__chart"><table><thead><tr><th>SIZE</th>`;
      columns.forEach((col) => {
        html += `<th>${col}</th>`;
      });
      html += `</tr></thead><tbody>`;
      allSizes.forEach((size) => {
        html += `<tr><td>${size}</td>`;
        columns.forEach((col) => {
          html += `<td>${data[col][size] ?? ""}</td>`;
        });
        html += `</tr>
`;
      });
      html += `</tbody>
</table></div>`;
      return html;
    }
    handleConvertToCm(data) {
      const convertData = [];
      const needDecimalsKeys = ["feet"];
      for (let unit of this.units) {
        const result = {};
        const temp = {};
        const unitKeyLower = (unit.key || "").toLowerCase();
        for (const size in data) {
          temp[size] = {};
          for (const key in data[size]) {
            const value = data[size][key];
            const lowerKey = key.toLowerCase();
            // 跳过weight字段
            if (lowerKey.includes("weight")) {
              temp[size][key] = value;
              continue;
            }
            // 跳过feet/英寸格式的字段
            const isFeetNotation = typeof value === "string" && (value.includes("'") || value.toLowerCase().includes("ft"));
            if (isFeetNotation) {
              temp[size][key] = value;
              continue;
            }
            // 如果字段已经是指定单位的格式，跳过转换
            // 例如：如果当前单位是"inch"，且字段名包含"(in)"，则跳过转换
            // 如果当前单位是"cm"，且字段名包含"(cm)"，则跳过转换
            const isInchField = lowerKey.includes("(in") || lowerKey.includes(" inch") || lowerKey.includes("in)");
            const isCmField = lowerKey.includes("(cm") || lowerKey.includes(" cm") || lowerKey.includes("centimeter");
            if ((unitKeyLower === "inch" && isInchField) || (unitKeyLower === "cm" && isCmField)) {
              temp[size][key] = value;
              continue;
            }
            // 处理用 "-" 分隔的范围值（例如 "68-110"）
            if (typeof value === "string" && value.includes("-")) {
              const [min, max] = value.split("-").map((v) => parseFloat(v.trim()));
              if (!isNaN(min) && !isNaN(max)) {
                const convertedMin = needDecimalsKeys.includes(unit.key) ? +(min / unit.convertToCm).toFixed(1) : Math.round(min / unit.convertToCm);
                const convertedMax = needDecimalsKeys.includes(unit.key) ? +(max / unit.convertToCm).toFixed(1) : Math.round(max / unit.convertToCm);
                temp[size][key] = `${convertedMin}-${convertedMax}`;
              } else {
                temp[size][key] = value;
              }
            }
            // 处理用 "/" 分隔的值（例如 "68/110"）
            else if (typeof value === "string" && value.includes("/")) {
              const parts = value.split("/").map((v) => v.trim());
              const convertedParts = parts.map((part) => {
                const num = parseFloat(part);
                if (!isNaN(num)) {
                  const converted = needDecimalsKeys.includes(unit.key) ? +(num / unit.convertToCm).toFixed(1) : Math.round(num / unit.convertToCm);
                  return converted.toString();
                }
                return part;
              });
              temp[size][key] = convertedParts.join("/");
            }
            // 处理单个数字值
            else if (!isNaN(value)) {
              const converted = needDecimalsKeys.includes(unit.key) ? +(parseFloat(value) / unit.convertToCm).toFixed(1) : Math.round(parseFloat(value) / unit.convertToCm);
              temp[size][key] = converted;
            } else {
              temp[size][key] = value;
            }
          }
        }
        result.data = temp;
        result.unit = unit;
        convertData.push(result);
      }
      return convertData;
    }
    handleDefaultSizeGuide() {
      const jsonScript = this.querySelector('script[data-name="json-default-size-chart"][type="application/json"]');
      if (jsonScript) {
        const jsonData = JSON.parse(jsonScript.textContent);
        for (let { data, unit } of this.handleConvertToCm(jsonData)) {
          const chartsElement = this.querySelector(
            `.sm-size-chart__content[data-section="default"][data-key="${unit.key}"] .sm-size-chart__charts--default`
          );
          if (chartsElement) {
            const transformedData = this.transformDefaultDataForUnit(data, unit.key);
            chartsElement.innerHTML = this.handleTableHtml(transformedData);
          }
        }
      }
    }
    handleExclusiveSizeGuide() {
      const jsonScript = this.querySelector('script[data-name="json-exclusive-size-chart"][type="application/json"]');
      if (jsonScript) {
        const jsonData = JSON.parse(jsonScript.textContent);
        for (let { data } of jsonData) {
          for (let item of this.handleConvertToCm(data)) {
            let chartsElement = this.querySelector(
              `.sm-size-chart__content[data-section="exclusive"][data-key="${item.unit.key}"] .sm-size-chart__charts--exclusive`
            );
            if (chartsElement) {
              chartsElement.innerHTML = this.handleTableHtml(item.data);
            }
          }
        }
      }
    }
  }
  customElements.define("size-size-modal", SizeChartModal);
}
if (!customElements.get("product-properties")) {
  class ProductProperties extends HTMLElement {
    constructor() {
      super();
      const inputs = this.querySelectorAll(".sm-product-properties input");
      inputs.forEach((input) => {
        input.addEventListener("input", function() {
          const regex = new RegExp(input.dataset.regex);
          const value = input.value;
          if (!regex.test(value)) {
            input.value = this.dataset.oldValue || "";
          } else {
            this.dataset.oldValue = value;
          }
        });
      });
    }
  }
  customElements.define("product-properties", ProductProperties);
}
